<template>
  <div class="sf-container tw-text-center">
    <div class="tw-my-8">
        <CheckSvg :scale="2" class="result-ok2 tw-block tw-mx-auto" />
    </div>
    <div class="tw-text-primary">
      <p>Your payment has been successful.</p>
      <p>You should have received an email with your username and password.</p>
      <p v-if="showLoginLink">
        You can now <a href="" @click.prevent="showLogin">log in</a>.
      </p>
    </div>
  </div>
</template>

<script lang="ts">      
import { setLoginVisible } from "@/state/appState";
import CheckSvg from "@/svg/CheckSvg.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { CheckSvg },
  computed: {
    showLoginLink() {
      return this.$userLoadStatus.value == 'loaded' &&!this.$currentUser.value;
    }
  },
  methods: {
    showLogin() {
      setLoginVisible(true);
    }
  },
});
</script>
